import { useContext, useState } from 'react';
import Dialog from '@/components/Dialog';
import CollapsibleActionMenu from '@/components/CollapsibleActionMenu';
import { FormattedMessage } from 'react-intl';
import ModelsContext from '@/pages/EditorPage/ChallengeModelsEditor/ModelsContext';
import SectionContext from '../../SectionContext';
import useApi from '@/lib/api/useApi';
import SelectedModelIdContext from '../../../../SelectedModelIdContext';

const DeleteSection = () => {
  const api = useApi();

  const [, setModels] = useContext(ModelsContext);
  const selectedModelId = useContext(SelectedModelIdContext);
  const { section } = useContext(SectionContext);

  const [confirmationDialogOpen, setConfirmationDialogOpen] = useState(false);
  const [deleting, setDeleting] = useState(false);

  const deleteSection = async (): Promise<void> => {
    setDeleting(true);
    setConfirmationDialogOpen(false);

    await api.delete(`editor/challenge-model/sections/${section.id}`);

    setModels(models => {
      delete models[selectedModelId].sections[section.id];
    });

    setDeleting(false);
  };

  return (
    <>
      <CollapsibleActionMenu.DeleteButton
        onClick={() => setConfirmationDialogOpen(true)}
        disabled={deleting}
      >
        <FormattedMessage id="editor.model_editor.actions.delete" />
      </CollapsibleActionMenu.DeleteButton>
      <Dialog
        open={confirmationDialogOpen}
        onClose={() => setConfirmationDialogOpen(false)}
        dangerous
      >
        <Dialog.Title>
          <FormattedMessage id="editor.model_editor.section_editor.delete.title" />
        </Dialog.Title>
        <Dialog.Content>
          <Dialog.ContentText>
            <FormattedMessage id="editor.model_editor.section_editor.delete.text" />
          </Dialog.ContentText>
        </Dialog.Content>
        <Dialog.Actions>
          <Dialog.Actions.CancelButton
            onClick={() => setConfirmationDialogOpen(false)}
          />
          <Dialog.Actions.DeleteButton onClick={deleteSection} />
        </Dialog.Actions>
      </Dialog>
    </>
  );
};

export default DeleteSection;
